/**
 * These constants help writing alignment anchors of PIXI Sprite,
 * BitmapText and similar objects in a better descriptive way.
 *
 * Example:
 * ```
 * new PIXI.Sprite().anchor.set(ANCHOR_RIGHT, ANCHOR_BOTTOM)
 * ```
 */

export const ANCHOR_LEFT = 0;
export const ANCHOR_TOP = 0;
export const ANCHOR_CENTER = 0.5;
export const ANCHOR_RIGHT = 1;
export const ANCHOR_BOTTOM = 1;
